<div id="login_modal" class="" role="dialog">
    <div class="modal-content">
        <div class="modal-body mt-5 mb-5">
           <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"><i class="fa-solid fa-xmark" (click)="dismiss()"></i></span>
           </button>
           <div class="row">
              <div class="col-md-6">
              </div>
              <div class="col-md-6">
                 <div class="login_here">
                    <form id="login-form" class="form_login" [formGroup]="userSignUp">
                     <div class="my-logo white" style="margin: 0rem auto 2rem;">
                        <svg viewBox="0 0 127 122" fill="none">
                          <path d="M72.85 104.24L71.17 94.2599C71.05 93.5199 70.34 93.02 69.6 93.15L40.66 98.2299C39.96 98.3499 39.48 99 39.55 99.7L40.62 109.92C40.7 110.7 41.43 111.25 42.2 111.11L71.75 105.78C72.49 105.66 72.98 104.97 72.85 104.24Z" />
                          <path d="M85.71 16.1499L18.63 77.0499L91.03 25.4099L122.01 75.5599L84.2 3.49994C78.7 1.83994 72.86 0.939941 66.82 0.939941C33.65 0.939941 6.76001 27.8299 6.76001 60.9999C6.76001 66.5599 7.53001 71.93 8.95001 77.03L7.86002 79.5399L0.830017 83.78L8.53001 80.9899L9.75002 79.6899C9.75002 79.6999 9.75001 79.7 9.76001 79.71L79.55 6.56995L85.71 16.1499Z" />
                          <path d="M96.34 8.7002L126.74 64.9702C126.83 63.6602 126.88 62.3402 126.88 61.0002C126.88 38.5602 114.57 19.0102 96.34 8.7002Z" />
                          <path d="M80.06 103.9C80.71 108.03 77.94 111.91 73.82 112.63L46.26 117.45C52.67 119.79 59.59 121.06 66.81 121.06C91.88 121.06 113.36 105.69 122.36 83.8599L78.15 91.8499L80.06 103.9Z" />
                          <path d="M22.21 101.22L20.23 101.54L10.01 109L24.13 103.21C27.23 106.35 30.66 109.16 34.39 111.55L32.58 99.52L22.21 101.22Z" />
                        </svg>
                        <div class="my-logo--content">
                          <div class="my-logo--content__beta">Admin</div>
                          <div class="my-logo--content__title">Kachiing</div>
                          <div class="my-logo--content__desc">We Recommend the Good Stuff</div>
                        </div>
                      </div>
                       <!-- <h3 class="text-center"><img loading="lazy" src="../../../assets/images/new/myvip_logo.png"></h3> -->
                       <!-- <h3 class="text-center">Welcome back!</h3> -->
                       <div class="form-group">
                          <input type="email" autocomplete="off" class="form-control" id="email" formControlName="usersEmail" placeholder="Email">
                          <ng-container *ngIf="submitted && userIn.usersEmail.errors">
                            <p class="error-message" *ngIf=" userIn.usersEmail.errors.required">
                                Email is required!
                            </p>
                            <p class="error-message" *ngIf=" userIn.usersEmail.errors.email">
                                Enter Valid Email.
                            </p>
                        </ng-container>
                       </div>
                       <div class="form-group">
                          <input type="password" class="form-control" id="pwd" formControlName="usersPassword" placeholder="Password">
                          <ng-container *ngIf="submitted && userIn.usersPassword.errors">
                            <p class="error-message" *ngIf=" userIn.usersPassword.errors.required">
                                Password is required!
                            </p>
                            <p class="error-message" *ngIf=" userIn.usersPassword.errors.minlength">
                                Password should be minimum of 5 characters.
                            </p>
                        </ng-container>
                       </div>
                       <div class="form-group">
                        <input type="password" class="form-control" id="pwd" formControlName="usersPasswordConfirm" placeholder="Confirm Password">
                        <ng-container *ngIf="submitted && userIn.usersPasswordConfirm.errors">
                          <p class="error-message" *ngIf=" userIn.usersPasswordConfirm.errors.required">
                              Confirm password is required!
                          </p>
                          <p class="error-message" *ngIf=" userIn.usersPasswordConfirm.errors.minlength">
                              Password should be minimum of 5 characters.
                          </p>
                      </ng-container>
                     </div>
                       <div class="row align-items-center remmber_box mt-2">
                          <div class="col-6">

                          </div>
                          <div class="col-6">
                             
                          </div>
                       </div>
                       <div class="form-group">
                          <div class="row align-items-center">
                             <div class="col-md-12 text-center">
                                <div class="login_button mt-4">
                                   <a class="btn_design sing_in_btn" (click)="usersignup()"> SIGNUP </a>
                                </div>
                             </div>
                          </div>
                          <div class="row align-items-center">
                             <div class="col-md-12">
                                <div class="create_button text-center">
                                   <span> Do you have an Account? <a (click)="open_login_modal()"> Log In</a> </span>
                                </div>
                             </div>
                          </div>
                       </div>
                    </form>
                 </div>
              </div>
           </div>
        </div>
     </div>
</div>